import cx from "classnames";
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react";

type SelectableCardExtraProps = {
  isSelected?: boolean;
  isDisabled?: boolean;
};

export type SelectableCardProps = SelectableCardExtraProps &
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const SelectableCard = ({
  children,
  className,
  isDisabled = false,
  isSelected = false,
  ...props
}: PropsWithChildren<SelectableCardProps>) => (
  <div
    className={cx(
      "relative border rounded-lg flex items-center justify-center overflow-hidden",
      isSelected
        ? "bg-white border-black border-2 border-insite"
        : "border-black/35",
      { "cursor-pointer": !isDisabled },
      className,
    )}
    {...props}
  >
    {isDisabled && <div className="absolute z-20 w-full h-full bg-brown/15" />}
    {children}
  </div>
);
